/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { CenteredColumn } from 'src/styles';

export const CommitStat = styled.span`
  & + & {
    margin-left: ${gridSize() * 2}px;
  }
`;

export const PaginationContainer = styled.div`
  padding: ${gridSize()}px 0;
`;

export const CommitListContainer = styled.div`
  display: flex;
  position: relative;
  min-height: 100px;
  margin-bottom: ${gridSize() * 4}px;
`;

export const CommitGraphContainer = styled.div`
  ${media.upToLarge(`
    display: none;
  `)};
  box-sizing: border-box;
  padding-right: ${gridSize() * 2}px;
  display: flex;
  justify-content: flex-end;
`;

export const EmptyResults = styled(CenteredColumn)`
  margin-top: ${gridSize() * 4}px;
`;

// Custom style needed to properly align the tag before icon
export const CommitListTag = styled.div`
  span > span {
    margin-top: ${gridSize() / 8}px;
    margin-left: ${gridSize() / 4}px;
  }
`;
